import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiCheckbox from '@material-ui/core/Checkbox';
import { Indeterminate as indeterminateIcon, Selects as selectIcon, Unselect as unSelectIcon, } from '@ringcentral/juno-icon';
import { combineClasses, styled, useDeprecatedCheck, useThemeProps, } from '../../../foundation';
import { withTooltip } from '../../Tooltip';
import { RcFormControlLabel } from '../FormControlLabel';
import { CustomIconPropsGetter } from '../utils';
import { CheckboxStyle } from './styles';
import { RcCheckboxClasses } from './utils';
var getIconProps = CustomIconPropsGetter({
    icon: unSelectIcon,
    checkedIcon: selectIcon,
    indeterminateIcon: indeterminateIcon,
});
var _RcCheckbox = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcCheckbox' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcCheckbox, props, [
            {
                prop: 'iconSize',
                time: '2021-4',
                comment: "@deprecated using size to replace that",
            },
        ]);
    }
    var label = props.label, formControlLabelProps = props.formControlLabelProps, color = props.color, error = props.error, followColorWhenUnChecked = props.followColorWhenUnChecked, classesProp = props.classes, iconSize = props.iconSize, sizeProp = props.size, icon = props.icon, checkedIcon = props.checkedIcon, rest = __rest(props, ["label", "formControlLabelProps", "color", "error", "followColorWhenUnChecked", "classes", "iconSize", "size", "icon", "checkedIcon"]);
    var size = sizeProp;
    // TODO: switch to size
    if (iconSize) {
        size = iconSize;
    }
    var classes = useMemo(function () { return combineClasses(RcCheckboxClasses, classesProp); }, [classesProp]);
    var iconProps = useMemo(function () { return getIconProps({ size: size, icon: icon, checkedIcon: checkedIcon }); }, [checkedIcon, icon, size]);
    var Checkbox = (React.createElement(MuiCheckbox, __assign({}, iconProps, rest, { ref: ref, color: "default", classes: classes })));
    if (label) {
        return (React.createElement(RcFormControlLabel, __assign({}, formControlLabelProps, { label: label, control: Checkbox })));
    }
    return Checkbox;
});
var RcCheckbox = styled(withTooltip(_RcCheckbox))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CheckboxStyle);
RcCheckbox.displayName = 'RcCheckbox';
RcCheckbox.defaultProps = {
    color: 'interactive.f01',
    size: 'medium',
};
export { RcCheckbox };
var templateObject_1;
